export default __webpack_public_path__ + "static/ag-grid-inverted-46374b1ed517bcde06f4519b75c85860.svg";